import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const ManualAutoMergeModal = memo(function ManualAutoMergeModal({
  isOpen,
  onClose,
  onConfirm,
  numSelectedGroups,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  numSelectedGroups: number;
}) {
  const { t } = useTranslation();
  const [merging, setMerging] = useState(false);

  const handleConfirm = useHandler(async () => {
    setMerging(true);
    await onConfirm();
    setMerging(false);
    onClose();
  });

  const primaryButton: RedoModalButtonProps = {
    text: t("Apply automerge"),
    onClick: handleConfirm,
    pending: merging,
  };

  const secondaryButton: RedoModalButtonProps = {
    text: t("Cancel"),
    onClick: onClose,
    disabled: merging,
    pending: false,
  };

  return (
    <RedoModal
      buttonPlacement="tight"
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title={t("Apply automerge on selected orders")}
    >
      <Flex dir="column" gap="xl">
        <Text fontSize="sm" textColor="primary">
          This will attempt to apply automerge to the {numSelectedGroups}{" "}
          selected {numSelectedGroups === 1 ? "fulfillment" : "fulfillments"}.
          Only {numSelectedGroups === 1 ? "fulfillment" : "fulfillments"} in a
          mergeable state will be considered for merging. This process may take
          a few minutes to complete.
        </Text>
      </Flex>
    </RedoModal>
  );
});
